module.exports = __webpack_public_path__ + "static/ogimage-97951fae13c0bcad0877a91927b1167e.png";